export default defineI18nConfig(() => ({
  silentTranslationWarn: true,
  missingWarn: import.meta.env.DEV,
  numberFormats: {
    'en-GB': {
      currency: {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'symbol',
      },
    },
    'de-DE': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'de-AT': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'pl-PL': {
      currency: {
        style: 'currency',
        currency: 'PLN',
        currencyDisplay: 'symbol',
      },
    },
    'pt-PT': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'es-ES': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'it-IT': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'nl-NL': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'cs-CZ': {
      currency: {
        style: 'currency',
        currency: 'CZK',
        currencyDisplay: 'symbol',
      },
    },
    'sk-SK': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'hu-HU': {
      currency: {
        style: 'currency',
        currency: 'HUF',
        currencyDisplay: 'symbol',
      },
    },
    'sl-SI': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'hr-HR': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    'ro-RO': {
      currency: {
        style: 'currency',
        currency: 'RON',
        currencyDisplay: 'symbol',
      },
    },
    'bg-BG': {
      currency: {
        style: 'currency',
        currency: 'BGN',
        currencyDisplay: 'symbol',
      },
    },
  },
}));
